<template>
  <div class="question-answer-component">
    <h1 class="title is-size-4">
      Q&A ({{ questionAnswers.length }})
      <b-tooltip v-if="owner" position="is-right" type="is-success" label="Add new Q&A">
        <a @click="isAddQaModalActive = true">
          <b-icon size="is-small" type="is-success" icon="plus-thick"></b-icon>
        </a>
      </b-tooltip>
    </h1>
    <h2 class="subtitle is-italic is-size-6">
      Questions and answers related to the Project
    </h2>

    <div class="columns is-multiline">
      <div class="column is-full">
        <draggable v-model="questionAnswers" @change="changed" :disabled="!owner">
          <div class="box" v-for="qa in questionAnswers" :key="qa.id">
            <div class="columns is-vcentered">
              <!-- Drag Burger -->
              <div v-if="owner" class="column is-narrow">
                <b-icon icon="menu"></b-icon>
              </div>

              <!-- QA Item Content -->
              <div class="column">
                <p>
                  <strong>
                    <b-icon size="is-small" icon="comment-question-outline"></b-icon>
                    {{ qa.attributes.question }}
                  </strong>
                </p>
                <p>
                  <b-icon size="is-small" icon="chevron-double-right"></b-icon>
                  {{ qa.attributes.answer }}
                </p>
              </div>

              <!-- QA Item edit Options -->
              <div class="column is-narrow">
                <a @click="triggerQaEditing(qa)">
                  <b-icon type="is-success" icon="pencil"></b-icon>
                </a>
                <a @click="deleteQa(qa)">
                  <b-icon type="is-danger" icon="delete"></b-icon>
                </a>
              </div>
            </div>
          </div>
        </draggable>
      </div>

      <b-modal
        :active.sync="isAddQaModalActive"
        :can-cancel="modalCancellable"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-modal
      >
        <add-question-answer-modal
          @qaCreated="updateQuestionAnswers"
          :askableType="askableType"
          :askableId="askableId"
        />
      </b-modal>

      <b-modal
        :active.sync="isEditQaModalActive"
        :can-cancel="modalCancellable"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-modal
      >
        <edit-question-answer-modal
          @qaUpdated="updateQuestionAnswers"
          :askableType="askableType"
          :askableId="askableId"
          :qa="targetedQa"
        />
      </b-modal>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { notificationMixin } from '@/mixins/notificationMixin'
import EditQuestionAnswerModal from '@/components/concerns/QuestionsAnswers/EditQuestionAnswerModal'
import AddQuestionAnswerModal from '@/components/concerns/QuestionsAnswers/AddQuestionAnswerModal'

export default {
  props: ['askableType', 'askableId', 'owner'],
  mixins: [notificationMixin],
  data () {
    return {
      questionAnswers: [],
      isAddQaModalActive: false,
      isEditQaModalActive: false,
      modalCancellable: [true, true, false],
      targetedQa: null
    }
  },
  components: {
    draggable,
    EditQuestionAnswerModal,
    AddQuestionAnswerModal
  },
  created () {
    this.$store
      .dispatch('questionAnswers/index', {
        askableType: this.askableType,
        askableId: this.askableId
      })
      .then((resp) => {
        this.questionAnswers = resp.data.data
      })
      .catch((_) => {
        // TODO: Handle error
        console.log('Error')
      })
  },
  methods: {
    triggerQaEditing (qa) {
      this.targetedQa = qa
      this.isEditQaModalActive = true
    },
    deleteQa (qa) {
      this.$buefy.dialog.confirm({
        message: 'Are you sure to delete this QA?',
        onConfirm: () => {
          this.$store
            .dispatch('questionAnswers/destroy', {
              askableType: this.askableType,
              askableId: this.askableId,
              qaId: qa.id
            })
            .then((resp) => {
              this.updateQuestionAnswers(resp.data.data)
            })
            .catch((error) => {
              // TODO: Handle error
              console.log(error.response.data)
            })
        }
      })
    },
    updateQuestionAnswers (value) {
      this.questionAnswers = value
      this.actionSuccess('QA Succesfully Updated')
    },
    changed (e) {
      this.$store
        .dispatch('questionAnswers/update', {
          askableType: this.askableType,
          askableId: this.askableId,
          qaId: e.moved.element.id,
          payload: { askable_order_position: e.moved.newIndex }
        })
        .then((resp) => {
          this.questionAnswers = resp.data.data
        })
        .catch((error) => {
          // TODO: Handle error
          console.log(error.response.data)
        })
    }
  }
}
</script>
